const countries = ["United States", "United Kingdom", "Canada", "Mexico", "Germany", "France"];

export default countries;



// WEBPACK FOOTER //
// ./src/util/countries/index.js